import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  UserState,
  initUser,
  initIsAuthenticated,
  initSelectedAccount,
  initCsrfToken,
  initCsrfParameterName,
} from './UserReducer';

export const selectUserState = createFeatureSelector<UserState>('user');

export const initUserSelector = createSelector(selectUserState, initUser);

export const initIsAuthenticatedSelector = createSelector(
  selectUserState,
  initIsAuthenticated,
);

export const initSelectedAccountSelector = createSelector(
  selectUserState,
  initSelectedAccount,
);

export const initCsrfTokenSelector = createSelector(
  selectUserState,
  initCsrfToken,
);

export const initCsrfParameterNameSelector = createSelector(
  selectUserState,
  initCsrfParameterName,
);
